import { Redirect, Route } from "react-router";
import jwt, { JwtPayload } from 'jsonwebtoken';

import UseAuth from "../hooks/UseAuth";

import { LoadingScreen } from "pages/Loading/LoadingScreen";

export const PrivateRoute = ({ component: Component, path: Path, ...rest }: any) => {
  const { accessToken, loading } = UseAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  function isSectionActive() {
    if (!accessToken) {
      return false;
    }
    const tokenPayLoad = jwt.decode(accessToken) as JwtPayload;

    if (tokenPayLoad === null) {
      return false;
    }
    const { iat } = tokenPayLoad;

    if (!iat) {
      return false;
    }

    return !(iat <= 0);
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        isSectionActive() ? <Component {...props} /> : <Redirect to="/login" />
      )}
    />
  )
}
